import Component from '@glimmer/component'
import type ReportNavigatorService from 'district-ui-client/services/report-navigator'
import { PageSummary } from 'district-ui-client/components/base/page-summary'
import { PageSize } from 'district-ui-client/components/base/page-size'
import BasePageSelector from 'district-ui-client/components/base/page-selector'
import { service } from '@ember/service'
import { eq } from 'ember-truth-helpers'

export interface PageMeta {
  page_number: number
  page_size: number
  total_entries: number
  total_pages: number
}

interface PageControlsSignature {
  Element: HTMLTableSectionElement
  Args: {
    meta: PageMeta
  }
}

export class PageControls extends Component<PageControlsSignature> {
  @service reportNavigator!: ReportNavigatorService

  updatePageSize = (pageSize: number) => {
    this.reportNavigator.updateQueryParams({ perPage: pageSize })
  }

  <template>
    {{#unless (eq @meta.total_entries 0)}}
      <div class="px-6 pb-6 pt-4">
        <div class="flex items-center justify-between">
          <PageSummary @meta={{@meta}} />
          <PageSize @value={{@meta.page_size}} @onChange={{this.updatePageSize}} />
        </div>
        <BasePageSelector @pageCount={{@meta.total_pages}} />
      </div>
    {{/unless}}
  </template>
}
